import { padding } from "@mui/system";

interface CardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  padding?: string;
}

const Card: React.FC<CardProps> = ({ title, children, className, padding }) => {
  return (
    <div className={`flex flex-col w-full text-center font-semibold bg-black rounded-md ${className ?? ""}`}>
      <h3 className={`text-sm 2xl:text-lg bg-darkerBlack rounded-t-md ${padding ? padding : " p-2"}`}>{title}</h3>
      <div className="flex-1 flex items-center justify-center">
        {children}
      </div>
    </div>
  );
};

export default Card;